import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from '../../../core/auth.service';
import { TokenService } from '../../../core/token.service';
import { Router } from '@angular/router';
import { ToastService } from '@app/services/toast.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],})
export class PageNotFoundComponent implements OnInit {
  constructor(private location: Location,
    private authService:AuthService,
    private router: Router, private toastr: ToastService)
    {}

  goBack(): void {
    
   // this.location.back();

   if (window.history.length > 1) {
    this.location.back();
  } else {
    this.router.navigate(['/login']); // or any fallback route
  }
  

  }
  ngOnInit() {
   
    this.checkAuthAndRedirect();
    //  this.authService.checkNRefreshToken();
    // this.checkNRefreshToken();
    //  const refreshTokenResponse: any = await this.checkNRefreshToken();

  // this.authService.CheckTokenValidorNot().subscribe((response:any)=>{
  //   if (response?.error_code === 8 || response?.error_code === 9) {
  //     if(response?.msg=='Refresh token is expired.'){
  //     }
  //       // this.tokenService.clearToken();
  //       localStorage.clear();
  //       // this.router.navigate(['/login']); // Uncomment to redirect to login page
  //     }
  // })
  }

  checkAuthAndRedirect(): void {
    const requiredKeys = ['isLogin', 'refreshToken', 'token', 'user_type', 'username','position_type'];
    console.log(requiredKeys)
    
    let isInvalid = false;

    requiredKeys.forEach(key => {
      const value = localStorage.getItem(key);
      // console.log(`Checking key: ${key}, value in localStorage:`, value, typeof value);

      if (value === null || value === 'null' || value==='') {
        // console.log(`Key ${key} is either missing or explicitly set to null.`);
        isInvalid = true;
      }
    });

    // console.log(`Is any key invalid? ${isInvalid}`); // Debugging line
    if (isInvalid) {
      localStorage.clear();  
      this.toastr.error('Invalid local storage data. You will be redirected to login.', 'Session Expired', {
        timeOut: 3000,  // Duration of the toast (in ms)
      });
      this.router.navigate(['/login']);  
    }
  }
  async checkNRefreshToken(){
    const refreshTokenResponse: any = await this.authService.checkNRefreshToken();
    console.log(refreshTokenResponse,'refreshTokenResponse')
  }
}